module.exports = __webpack_public_path__ + "static/media/studio_articulated_loader_mla_3_25_h_cabin_manitou_004.0b3e9856.png";